import { API_URL } from "../config";
import Form from "./Form";
import React from "react";
import { withRouter } from "react-router-dom";

class Execute extends React.Component {
  state = {
    record: null,
    loading: false,
    error: null,
  };

  componentDidMount() {
    const { location, match } = this.props;
    const procedureName = match?.params?.name;

    if (location?.state?.record) {
      // Navigazione normale: record già passato
      this.setState({ record: location.state.record });
    } else if (procedureName) {
      // Refresh o accesso diretto via URL
      this.fetchProcedure(procedureName);
    } else {
      this.notify("Nome procedura mancante", "warning");
    }
  }

  fetchProcedure = async (procedureName) => {
    const token = localStorage.getItem("token");
    const locale = localStorage.getItem("locale") || "it";

    if (!token || !procedureName) {
      this.notify("Token o nome procedura mancante", "warning");
      return;
    }

    const body = {
      token,
      lang: locale,
      sort: { column: "id", descending: true },
      page: 1,
      limit: 10,
      resource: "procedure",
      filters: [
        {
          name: "name",
          clause: "eq",
          value: procedureName,
        },
      ],
    };

    this.setState({ loading: true, error: null });

    try {
      const response = await fetch(`${API_URL}/procedure/list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (!Array.isArray(result.rows) || result.rows.length === 0) {
        throw new Error(`Procedura "${procedureName}" non trovata`);
      }

      const record = result.rows[0];
      this.setState({ record, loading: false });
    } catch (error) {
      this.setState({ error: error.message, loading: false });
      this.notify(`Errore: ${error.message}`, "warning");
    }
  };

  notify = (message, type = "info") => {
    alert(`${type.toUpperCase()}: ${message}`);
  };

  redirect = (path) => {
    const { history } = this.props;
    history.push(path);
  };

  render() {
    const { record, loading, error } = this.state;
    const { ...rest } = this.props;

    if (loading) return <p>Caricamento procedura...</p>;
    if (error) return <p style={{ color: "red" }}>Errore: {error}</p>;
    if (!record) return <p>Nessuna procedura trovata.</p>;

    return (
      <Form
        {...rest}
        record={record}
        notify={this.notify}
        redirect={this.redirect}
      />
    );
  }
}

export default withRouter(Execute);
